import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';
import { ModuleEnum } from 'src/app/models/ModuleEnum';
import { ModuleService } from 'src/app/services/module.service';

import Project from '../../models/Project';
import User from '../../models/User';
import { GetUserById } from '../../users/user.actions';
import { ProjectAssignResumeModalComponent } from '../project-assign-resume-modal/project-assign-resume-modal.component';
import { ProjectDeleteModalComponent } from '../project-delete-modal/project-delete-modal.component';
import { ProjectDetailModalComponent } from '../project-detail-modal/project-detail-modal.component';
import { FetchProjects } from '../project.actions';
import { ProjectState } from '../project.state';

@Component({
    selector: 'app-project-detail-resumes',
    templateUrl: './project-detail-resumes.component.html',
    styleUrls: ['./project-detail-resumes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ProjectDetailResumesComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    @Select(ProjectState.projects) projects$: Observable<Project[]>;
    @Input() project: Project;
    user: User;
    eModule = ModuleEnum;

    constructor(
        private route: ActivatedRoute,
        private store: Store,
        private modalService: NgbModal,
        public moduleService: ModuleService,
        private logger: NGXLogger,
    ) {}

    ngOnInit(): void {
        this.store.dispatch(new FetchProjects());
        this.subscriptions.add(
            this.route.params.subscribe((params) => {
                this.projects$.subscribe((projects) => (this.project = projects.filter((w) => w.uuid == params.id)[0]));
            }),
        );
        this.subscriptions.add(this.store.dispatch(new GetUserById(this.project.userId)).subscribe((state) => (this.user = state.user.userById)));
    }

    openWorkUpdateModal(project: Project) {
        this.logger.debug('Opening projectDetailModal');
        const modalRef = this.modalService.open(ProjectDetailModalComponent);
        modalRef.componentInstance.project = project;
        modalRef.componentInstance.isUpdate = true;
    }

    openWorkDeleteModal(project: string) {
        this.logger.debug('Opening workDeleteModal');
        const modalRef = this.modalService.open(ProjectDeleteModalComponent, {
            windowClass: 'modal-prompt',
        });
        modalRef.componentInstance.project = project;
    }

    openResumeAssignModal(projectUuid: string) {
        this.logger.debug('Opening workAssignResumeModal');
        const modalRef = this.modalService.open(ProjectAssignResumeModalComponent);
        modalRef.componentInstance.projectUuid = projectUuid;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
